import { Controller } from "@hotwired/stimulus";

export default class NewsletterSignup extends Controller {
  static targets = ["errorMessage", "form", "screen"];
  static values = {
    screen: String,
    errorMessage: String,
  };

  connect() {
  }

  error(message) {
    this.errorMessageValue = this.getFormattedErrorMessage(message);
    this.screenValue = "error";
  }

  reset() {
    this.screenValue = "form";
  }

  submit(event) {
    event.preventDefault();
    event.stopPropagation();

    const formArray = $(this.formTarget).serializeArray();
    const dataObj = {};
    formArray.forEach(item => {
      dataObj[item.name] = item.value;
    });
    const jsonData = JSON.stringify(dataObj);

    fetch(this.data.get("url"), {
      method: "POST",
      headers: {
        "Content-Type": "application/json; charset=utf-8",
      },
      body: jsonData, // assuming jsonData is already a JSON string
    }).then((response) => {
      if (!response.ok) {
        // Parse the JSON error message and throw it so we can catch it below
        return response.json().then((errorData) => {
          throw errorData;
        });
      }
      return response.json();
    }).then((data) => {
      this.success();
    }).catch((error) => {
      this.error(error.error.message);
    });
  }

  success() {
    this.screenValue = "success";
  }

  /*
  :::::::::::::
  :: Helpers ::
  :::::::::::::
  */
  getFormattedErrorMessage(errorMessage) {
    if (errorMessage.includes("email field must be a valid email address")) {
      return "Please enter a valid email address.";
    }

    if (errorMessage.includes("email field is required")) {
      return "The email field is required.";
    }

    return "Sorry, something went wrong. Please try again later.";
  }

  /*
  :::::::::::::::::::::::::::
  :: Value change handlers ::
  :::::::::::::::::::::::::::
  */
  screenValueChanged(screen) {
    this.screenTargets.forEach((el) => {
      const isCurrentScreen = el.dataset.newsletterSignupScreen === screen;
      el.style.setProperty("display", isCurrentScreen ? "flex" : "none");
      el.setAttribute("aria-hidden", !isCurrentScreen);
    });
  }

  errorMessageValueChanged(message) {
    if (!this.hasErrorMessageTarget) {
      return;
    }

    this.errorMessageTarget.textContent = message;
  }
}
